import type { SelectOption } from '@/components/ui/select'
import type { DataFile } from '@/types'

export const ALL_DEPARTMENTS_VALUE = 'all'

export const PRIORITY_OPTIONS: SelectOption[] = [
  { value: 'high', label: 'ระดับสูง' },
  { value: 'low', label: 'ระดับต่ำ' },
  { value: 'mixed', label: 'คละระดับ' },
]

export const PRIORITY_FILTER_OPTIONS: SelectOption[] = [{ value: '', label: 'ระดับทั้งหมด' }, ...PRIORITY_OPTIONS]

export function getDepartmentValues(departments?: DataFile['departments']) {
  const values = (departments ?? []).flatMap((department) => (department.id === null ? [] : [String(department.id)]))
  return values.length > 0 ? values : [ALL_DEPARTMENTS_VALUE]
}

export function getDepartmentIds(values: string[]): number[] {
  return values.includes(ALL_DEPARTMENTS_VALUE) ? [] : values.map(Number).filter(Number.isInteger)
}

export function getDepartmentSelection(current: string[], next: string[]): string[] {
  if (next.includes(ALL_DEPARTMENTS_VALUE) && !current.includes(ALL_DEPARTMENTS_VALUE)) {
    return [ALL_DEPARTMENTS_VALUE]
  }
  return next.filter((value) => value !== ALL_DEPARTMENTS_VALUE)
}
